export const jaTranslations = {
    "home": "ホーム",
    "community": "コミュニティ",
    "writing": "執筆",
    "store": "ストア",
    "my_channel": "マイチャネル",
    "title": "タイトル",
    "language_settings": "言語設定",
    "display_language": "表示言語",
    "select_language": "言語を選択",
    "korean": "韓国語",
    "english": "英語",
    "japanese": "日本語",
    "shipping_info": "配送先情報",
    "confirm_consent": "同意します",
    "disagree_consent": "同意しません",
    "enter_shipping": "配送先情報を入力",
    "check_shipping": "配送を確認",
    "shipping_preparing": "配送を準備中です。",
    "shipping_ready": "配送準備",
    "refund_completed": "払戻完了",
    "rewards_info": "賞品管理",
    "personal_info_consent": "賞品受け取りのための個人情報収集・利用契約",
    "collection_purpose": "収集・利用目的",
    "delivery_purpose": "イベント当選賞品の配送および配送",
    "retention_period": "保有期間",
    "retention_duration": "賞品配送完了後、最大3ヶ月",
    "collection_items": "個人情報収集項目",
    "collection_details": "名前、電話番号、配送先住所",
    "agree": "同意",
    "disagree": "同意しません",
    "next": "次へ",
    "complete": "完了",
    "change_address": "住所を変更",
    "delivery_guide": "商品受け取りガイド",
    "guide_1": "配送先情報の入力後、2週間以内に賞品を受け取ることができます。",
    "guide_2": "配送先情報の誤入力による責任は当選者本人にあります。",
    "guide_3_prefix": "賞品配送に関するお問い合わせは",
    "guide_3_suffix": "までお願いします。",
    "account_settings": "設定",
    "account_settings_title": "アカウントと設定",
    "notifications": "通知",
    "my_profile": "プロフィール",
    "logout": "ログアウト",
    "login_required": "この機能にはログインが必要です。",
    "back_to_login": "ログイン画面に移動しますか？",
    "later": "後で",
    "yes": "はい",
    "attendance": "チェックイン",
    "mission_participation": "チャレンジ",
    "roulette": "ルーレット",
    "submit_work": "作品投稿",
    "free_trial": "無料体験",
    "qualification_test": "資格試験",
    "post_news": "ニュース",
    "contact": "お問い合わせ",
    "membership": "メンバーシップ",
    "followers": "フォロワー",
    "following": "フォロー中",
    "edit_profile": "プロフィール編集",
    "invite_friends": "友達を招待",
    "level_suffix": "のレベルは",
    "daily_mission_title": "毎日のアクティビティミッションを達成してみよう！",
    "app_checkin": "アプリ出席チェック",
    "upload_post": "新しい投稿をアップロード",
    "follow_friend": "友達をフォロー",
    "posts": "投稿",
    "bookmarks": "お気に入り",
    "likes": "いいね",
    "comments": "コメント",
    "post_type": "投稿",
    "news_type": "ニュースレター",
    "product_type": "ジョーカーマーケット",
    "challenge_type": "チャレンジ",
    "all_type": "すべて",
    "just_now": "たった今",
    "minute_ago": "1分前",
    "minutes_ago": "分前",
    "hour_ago": "1時間前",
    "hours_ago": "時間前",
    "day_ago": "1日前",
    "days_ago": "日前",
    "week_ago": "1週間前",
    "weeks_ago": "週間前",
    "year_ago": "1年前",
    "years_ago": "年前",
    "remaining_points": "まで残りポイント",
    "level_text": "レベル",
    "grade": "等級",
    "member_benefits": "会員特典",
    "point_history": "ポイント履歴",
    "membership_info": "メンバーシップガイド",
    "membership_category": "区分",
    "membership_condition": "達成条件",
    "membership_level_up_points": "ランク達成時\nお祝いポイント",
    "membership_post_points": "記事作成時\n追加支給",
    "membership_discount_rate": "商品割引",
    "membership_like_reward": "いいね",
    "membership_comment_reward": "コメント",
    "membership_guest_condition": "入会時の\n初期ランク",
    "accumulated_points": "累積ポイント",
    "from": "から",
    "point_earning_methods": "ポイント獲得方法",
    "payment": "支払い",
    "payment_shipping_request": "支払い/配送申込",
    "shipping_address_management": "配送先管理",
    "qualification_exam_management": "資格試験管理",
    "notification_settings": "通知設定",
    "push_notifications": "プッシュ通知を受け取る",
    "event_ad_recommendation_notifications": "イベント/広告および推奨通知を受け取る",
    "announcements": "お知らせ",
    "faq": "よくある質問",
    "customer_support": "カスタマーサポート",
    "version_information": "バージョン情報",
    "terms_of_service": "利用規約",
    "privacy_policy": "プライバシーポリシー",
    "app_information_and_policies": "アプリ情報と利用規約/ポリシー",
    "login": "ログイン",
    "payment_shipping_history": "支払い/配送履歴",
    "payment_detail": "支払い詳細",
    "prize_registration_complete": "景品登録完了",
    "shipping_in_progress": "配送中",
    "enter_shipping_info": "配送先情報を入力",
    "roulette_reward": "ルーレット報酬",
    "no_rewards_history": "景品履歴がありません",
    "shipping_scheduled": "配送予定",
    "shipping_complete": "配送完了",
    "cancel_return": "キャンセル・返品",
    "exchange_application": "交換・返品申請",
    "link_not_exist": "リンクが存在しません",
    "confirm": "確認",
    "product_purchase": "商品購入",
    "point_exchange": "ポイント交換",
    "point_reason": "理由",
    "no_payment_shipping_history": "支払い/配送申請履歴がありません",
    "address_name": "配送先名",
    "address_name_placeholder": "配送先名を入力してください。",
    "recipient_name": "受取人名",
    "recipient_name_placeholder": "受取人名を入力してください。",
    "phone_number": "携帯電話番号",
    "phone_number_placeholder": "電話番号を入力してください。",
    "address": "住所",
    "address_search_placeholder": "住所検索",
    "address_search_button": "住所検索",
    "address_detail_placeholder": "詳細住所",
    "address_memo": "配送先メモ",
    "address_memo_placeholder": "小包保管場所、共同玄関暗証番号など",
    "save": "保存",
    "address_name_error": "配送先名を入力してください。",
    "address_name_max_error": "最大10文字まで入力可能です。",
    "recipient_name_error": "受取人名を入力してください。",
    "phone_number_error": "電話番号は10〜11桁である必要があります。",
    "address_error": "住所を入力してください。",
    "address_max_error": "住所は最大30文字まで入力可能です。",
    "address_memo_max_error": "配送先メモは最大20文字まで入力可能です。",
    "select": "選択",
    "delete": "削除",
    "edit": "編集",
    "no": "いいえ",
    "company": "会社",
    "recipient": "受取人",
    "delete_address_confirm": "配送先を削除しますか？",
    "delete_address_description": "削除された配送先は回復できず、<br />新しく登録する必要があります。",
    "default_address_set": "デフォルト配送先として設定されました。",
    "default_address_error": "デフォルト配送先の設定に失敗しました。",
    "address_deleted": "住所が削除されました。",
    "no_registered_address": "登録された配送先がありません。",
    "add_address_prompt": "配送先を追加してください！",
    "add_address": "配送先を追加",
    "max_address_limit": "配送先は最大5個まで登録できます。",
    "delete_address_to_add": "既存の配送先を削除してから、新しい配送先を追加してください！",
    "change_status": "ステータス変更",
    "report": "報告",
    "make_private": "非公開に切り替え",
    "make_public": "公開に切り替え",
    "hide_post": "投稿を非表示",
    "block_user": "ユーザーをブロック",
    "cancel": "キャンセル",
    "post_delete_confirm": "削除された投稿は復元できません。<br />本当に削除しますか？",
    "no_posts": "まだ投稿がありません。<br />最初の投稿をアップロードしてみてください。",
    "no_challenges": "進行中のチャレンジはありません。<br />もっと楽しいチャレンジを準備中です。",
    "error_occurred": "エラーが発生しました..もう一度お試しください",
    "no_bookmarks": "ブックマークがまだありません。<br />保存したい投稿をブックマークしてください。",
    "no_likes": "いいねした投稿がまだありません。<br />好きな投稿にいいねを押してください。",
    "no_comments": "まだコメントがありません。<br />友達とコメントを通じてコミュニケーションを取りましょう。",
    "view_all_channel": "チャネルをすべて表示",
    "coming_soon_title": "サービスを準備中です。",
    "coming_soon_description": "この機能は現在最終開発段階にあり、\nまもなくサービスに反映される予定です。\nお楽しみに！",
    "store_title": "ストア",
    "sort_method": "ソート方法",
    "sort_default": "デフォルト",
    "sort_popularity": "人気順",
    "sort_latest": "最新順",
    "sort_price_asc": "安い順",
    "sort_price_desc": "高い順",
    "sort_discount": "割引率順",
    "sort_sales": "販売数が多い順",
    "sort_reviews": "レビュー数が多い順",
    "sort_rating": "評価が高い順",
    "no_products": "商品がありません。",
    "category": "カテゴリー",
    "shipping_fee": "配送料",
    "coupon": "クーポン",
    "coupon_available_count": "利用可能 {count}枚",
    "coupon_register_or_none": "クーポン登録・選択",
    "point_use": "ポイント使用",
    "point_use_all": "全額使用",
    "point_use_hint": "保有 {balance}P · 商品金額の30%({cap}P)まで使用可能",
    "chk_point_hint_coupon_min_cash": "クーポンを使う場合、お支払い金額が最低100ウォン必要なため、このご注文ではポイントを併用できません。",
    "chk_point_hint_no_balance": "保有しているポイントがありません。",
    "chk_point_hint_unavailable": "このご注文ではポイントを使用できません。",
    "chk_coupon_register_link": "+ クーポン登録",
    "chk_coupon_applied_of": "利用可能{total}枚のうち1枚を適用中",
    "chk_coupon_cancel": "クーポンの適用を取り消す",
    "coupon_discount": "クーポン割引",
    "point_discount": "ポイント割引",
    "total_payment_amount": "最終お支払い金額",
    "book_page_locked": "購入後に閲覧できるページです",
    "book_buy_now": "購入する",
    "book_page": "ページ",
    "book_prev_page": "前のページ",
    "book_next_page": "次のページ",
    "book_zoom_out": "縮小",
    "book_zoom_in": "拡大",
    "book_not_found": "商品が見つかりません。",
    "book_load_error": "電子書籍情報を読み込めませんでした。",
    "book_viewer_title": "プレビュー",
    "book_no_pages": "閲覧できるページがありません。",
    "coupon_menu_title": "クーポン登録・保有クーポン",
    "cpn_register_title": "紙クーポン番号の登録",
    "cpn_code_placeholder": "8桁のクーポン番号",
    "cpn_code_hint": "クーポン裏面の8桁の番号を入力してください。",
    "cpn_register_success": "{amount}ウォンのクーポンを登録しました。お支払いの時に使えます。",
    "cpn_tab_available": "利用可能",
    "cpn_tab_history": "使用済み・期限切れ",
    "cpn_sort_available": "期限が近い順",
    "cpn_sort_history": "新しい順",
    "cpn_badge_used": "使用済み",
    "cpn_badge_expired": "期限切れ",
    "cpn_badge_voided": "使用不可",
    "cpn_partner_line": "{partner} 提携",
    "cpn_min_order": "{amount}ウォン以上のお支払いで使えます",
    "cpn_all_products": "全商品で使えます",
    "cpn_until": "{date} まで",
    "cpn_used_line": "{date} 使用",
    "cpn_used_line_order": "{date} 使用 · 注文番号 {orderId}",
    "cpn_expired_line": "{date} 期限切れ · 未使用",
    "cpn_history_notice": "注文を全部キャンセルすると、有効期限が残っているクーポンは「利用可能」タブに戻ります。",
    "my_ebooks_page_title": "購入した電子書籍",
    "coupon_select_title": "クーポン選択",
    "coupon_none_applicable": "利用可能なクーポンがありません。",
    "coupon_apply_amount": "-{amount}ウォン",
    "coupon_expires_until": "{date}まで",
    "coupon_selected": "選択済み",
    "coupon_dont_use": "クーポンを使わない",
    "coupon_go_register": "クーポンを登録する",
    "cpk_order_info": "注文金額 {order}ウォン · 1回のお支払いでクーポンは1枚まで使えます",
    "cpk_none": "クーポンを使わない",
    "cpk_banner": "クーポンの金額が注文金額より大きいと、残りの金額はなくなります。",
    "cpk_apply": "{amount}ウォン割引を適用する",
    "cpk_apply_none": "クーポンなしで進む",
    "cpk_register": "+ クーポン登録",
    "cpk_all_products": "全商品で使えます",
    "cpk_close": "閉じる",
    "cpk_min_order": "{amount}ウォン以上のお支払いで利用可能",
    "cpk_expires": "~ {date}",
    "chk_product_amount": "商品金額",
    "chk_payment_amount": "お支払い金額",
    "chk_title": "お支払い",
    "chk_order_product": "注文商品",
    "chk_ebook_label": "e-book",
    "chk_pay_suffix": "お支払い",
    "gate_banner_text": "新しいバージョンがあります",
    "gate_banner_update": "アップデート",
    "gate_banner_close": "閉じる",
    "gate_block_title": "アプリのアップデートが必要です",
    "gate_block_body": "お使いのバージョンはサポートが終了しました。\nストアで最新バージョンにアップデートしてから、もう一度開いてください。",
    "gate_block_note": "アカウント・ポイント・作品はそのまま残ります。\nマイルームなどの新機能は最新のアプリでのみご利用いただけます。",
    "gate_block_button": "アップデートする",
    "gate_block_no_store": "アプリストアで「ジョイサム コネクト」を検索してアップデートしてください。",
    "gate_block_help": "アップデートできない場合は、保護者の方に相談してください。\n端末の空き容量が少ない、または端末が古い場合もアップデートできないことがあります。",
    "coupon_register_success": "{amount}ウォンのクーポンを登録しました。",
    "coupon_register_failed": "クーポンを登録できませんでした。しばらくしてからもう一度お試しください。",
    "coupon_locked_notice": "約{minutes}分後に再試行できます。",
    "coupon_status_used": "使用済み",
    "coupon_status_expired": "期限切れ",
    "coupon_status_voided": "利用不可",
    "coupon_status_available": "利用可能",
    "coupon_min_order": "{amount}ウォン以上のご購入で利用可能",
    "coupon_none_usable_now": "今使えるクーポンはありません",
    "coupon_register_title": "クーポン登録",
    "coupon_code_label": "クーポン番号",
    "coupon_code_placeholder": "クーポン番号8桁(例: J1234567)",
    "coupon_register_button": "登録",
    "coupon_tab_available": "利用可能",
    "coupon_tab_history": "使用済み・期限切れ",
    "coupon_load_failed": "クーポン一覧を読み込めませんでした。",
    "coupon_empty_available": "利用可能なクーポンがありません。紙のクーポン番号を登録してください。",
    "coupon_empty_history": "使用済み・期限切れのクーポンはありません。",
    "load_more": "もっと見る",
    "my_ebooks_total": "合計",
    "my_ebooks_count_suffix": "冊",
    "my_ebooks_sort_label": "並べ替え",
    "my_ebooks_sort_recent_purchase": "購入が新しい順",
    "my_ebooks_sort_recent_read": "最近読んだ順",
    "my_ebooks_sort_title": "タイトル順",
    "my_ebooks_load_error": "電子書籍の一覧を読み込めませんでした。",
    "my_ebooks_go_store": "ストアへ",
    "my_ebooks_purchased_at": "購入日",
    "myebooks_completed": "読了",
    "myebooks_unread": "まだ読んでいません",
    "myebooks_purchased_suffix": "購入",
    "myebooks_order_no": "注文番号",
    "myebooks_resume": "続きを読む",
    "myebooks_start": "読み始める",
    "myebooks_empty_title": "購入した電子書籍はまだありません",
    "myebooks_empty_desc": "電子書籍を購入すると、ここから\nいつでも読み返せます。",
    "myebooks_browse": "電子書籍を見る",
    "ebook_menu_title": "購入した電子書籍",
    "my_benefits_title": "保有資産",
    "ebook_refund_consent": "電子書籍は閲覧を始めると返金が難しくなります。この内容を確認しました。",
    "read_ebook_now": "今すぐ読む",
    "my_ebooks_title": "購入した電子書籍",
    "my_ebooks_empty": "購入した電子書籍はありません。",
    "my_ebooks_pages_suffix": "ページ",
    "my_ebooks_view_all": "すべて見る",
    "my_ebooks_collapse": "閉じる",
    "ebook_no_shipping": "電子書籍・配送なし",
    "product_not_found": "商品が見つかりません。",
    "currency_won": "ウォン",
    "free_shipping_condition": "ただし、{threshold}{currency}以上のご注文で無料",
    "free_shipping_remaining": "あと{amount}{currency}で送料無料",
    "free_shipping_applied": "送料無料適用中",
    "currency_points": "P",
    "product_info": "商品情報",
    "product_details": "詳細",
    "product_description": "商品説明",
    "reviews": "レビュー",
    "no_faq": "FAQはありません。",
    "faq_loading_error": "FAQの読み込みに失敗しました。",
    "no_reviews": "まだレビューはありません。",
    "product_name": "商品名",
    "price": "価格",
    "purchase": "購入する",
    "quantity_select": "数量を選択",
    "total_amount": "合計金額",
    "payment_in_progress": "支払い処理中...",
    "payment_method": "支払い方法",
    "order_product": "注文商品",
    "order_checkout": "注文/支払い",
    "add_address_new": "配送先を追加+",
    "membership_discount": "メンバーシップ割引",
    "quantity_error": "この商品の最大数量に達しました。",
    "membership_discount_info": "*JoySamメンバーシップレベルによって割引率が異なります。",
    "cart_max_stock_reached": "商品「{name}」は既にカートに最大数量が入っています。",
    "cart_stock_exceeded": "「{name}」 - カートに追加できる上限はあと{n}個です。",
    "total_order_amount": "注文合計金額",
    "delivery_address": "配送先情報",
    "prize_guide": "景品受け取りガイド",
    "customer_service": "カスタマーサービス",
    "quantity_unit": "個",
    "select_delivery_address": "配送先を選択",
    "submission_complete": "提出完了",
    "payment_failed": "支払い失敗",
    "payment_error_message": "お支払いが正常に完了しませんでした。",
    "retry_instruction": "確認後、もう一度お試しください。",
    "go_to_home": "ホームに移動",
    "challenge_thanks": "チャレンジにご参加いただきありがとうございます。",
    "challenge_wish": "良い結果を期待しています。",
    "product_label": "商品",
    "and_others_count": "他 {count}件",
    "order_completed_message": "注文が\n完了しました。\n\nありがとうございます。",
    "post_tag": "投稿タグ",
    "user_nickname": "ユーザーニックネーム",
    "product_category": "商品",
    "search_keyword_placeholder": "検索キーワードを入力...",
    "recommended_keywords": "おすすめキーワード",
    "no_recommended_keywords": "おすすめキーワードがありません",
    "search_category": "検索カテゴリー",
    "no_search_results": "検索結果がありません。",
    "naver_login": "Naver でサインイン",
    "kakao_login": "Kakao でサインイン",
    "google_login": "Google でサインイン",
    "apple_login": "Apple でサインイン",
    "enter_invitation_code": "招待コードを入力",
    "account": "アカウント",
    "quick_login_settings": "クイックログイン設定",
    "other": "その他",
    "withdrawal": "退会",
    "nickname_error": "ニックネームは2文字以上で入力してください。",
    "email_error": "有効なメールアドレス形式で入力してください。",
    "phone_error": "電話番号の形式が正しくありません。",
    "file_size_error": "最大20MBまでアップロード可能です。",
    "saved": "保存されました。",
    "nickname_placeholder": "ニックネームを作成してください!",
    "edit_profile_image": "プロフィール画像を編集",
    "select_from_album": "アルバムから写真を選択",
    "set_default_image": "デフォルト画像に設定",
    "english_name_error": "英語の名前は2文字以上で入力してください。",
    "korean_name_error": "韓国語の名前は2文字以上で入力してください。",
    "age_error": "年齢を数字で入力してください。",
    "experience_error": "経験を数字で入力してください。",
    "email_placeholder": "メールアドレスを入力してください。",
    "korean_name": "名前(韓国語)",
    "korean_name_placeholder": "韓国語の名前を入力してください。",
    "english_name": "名前(英語)",
    "english_name_placeholder": "英語の名前を入力してください。",
    "birth_date": "生年月日",
    "birth_date_placeholder": "生年月日を入力してください。",
    "age_placeholder": "年齢を数字で入力してください。",
    "origami_experience": "折り紙経験",
    "numeric_only": "数字のみ入力してください。",
    "phone_placeholder": "電話番号を入力してください。",
    "gender": "性別",
    "male": "男性",
    "female": "女性",
    "check_invitation_code": "招待コードを確認してください",
    "points_earned": "ポイントが獲得されました。",
    "invitation_code_instruction": "友人から受け取った招待コードを<br />入力してください。",
    "invitation_code_placeholder": "招待コードを入力",
    "register": "登録",
    "email": "メール",
    "copied_to_clipboard": "クリップボードにコピーされました。",
    "my_invitation_code": "招待コード",
    "invite_friends_benefit": "友人がJoySamをインストールすると、<br />友人も私もポイントを獲得します。",
    "invitation_code_copy_guide": "招待コード領域を選択してクリップボードにコピーできます。",
    "invitation_code_limit_guide": "招待コードを通じたポイント獲得は最大50回まで可能です。50回を超える場合は、友人だけがポイントを獲得します。",
    "invite_friends_share_button": "共有する",
    "invite_friends_share_message": "JoySamで一緒に遊びましょう！登録後に招待コード {code} を入力すると、お互いにポイントがもらえます。",
    "age": "年齢",
    "country": "国",
    "submission_not_completed": "出品が完了していません。",
    "pay_submission_fee": "はい、お支払いします！",
    "feature_under_development": "この機能は鋭意開発中です。<br />素晴らしいアップデートでお会いしましょう！",
    "must_pay_before_submit": "新しいアプリケーションを送信する前に支払う必要があります。",
    "no_active_submission_challenge": "アクティブな作品投稿チャレンジがありません。",
    "challenge_fee_notice_part1": "本チャレンジは参加費",
    "challenge_fee_notice_part2": "円を納付する必要があります",
    "challenge_fee_notice_part3": "出品が完了します。\n\n参加しますか？",
    "featured_posts": "注目の投稿",
    "latest_posts": "最新の投稿",
    "view_more": "もっと見る",
    "joker_market": "ジョーカーマーケット",
    "joker_market_desc": "自分の作品やグッズ、用品、本を取引する",
    "board_desc": "自分の作品を自慢する",
    "no_related_questions": "関連する質問はまだありません。",
    "curious_title": "これが気になる",
    "no_faqs_registered": "登録されたFAQがありません。",
    "board": "掲示板",
    "newsletter": "ニュースレター",
    "point_exchange_shop": "ポイント交換所",
    "footer_terms_of_service": "利用規約",
    "footer_company": "会社: ジョイサム株式会社",
    "footer_ceo": "代表取締役: Kyuil Jung",
    "footer_address": "住所: ソウル龍山区元暁路90ギル11、龍山ビジネスセンター22号室203号",
    "footer_business_reg": "事業者登録番号: 503-87-03074",
    "footer_phone": "電話番号: 070-4621-3262",
    "footer_mail_order_reg": "通信販売業届出番号: 2026-서울용산-0302",
    "footer_email": "メール: joysam6061@gmail.com",
    "footer_copyright": "© ジョイサム コネクト. All rights reserved.",
    "dm_title": "のDM",
    "no_conversations": "会話がありません",
    "image_text": "[画像]",
    "deleted_message": "[削除されたメッセージ]",
    "user": "ユーザー",
    "no_notifications": "新しい通知はありません。",
    "attendance_check_in": "チェックイン",
    "attendance_already_participated": "今日はすでにチェックインミッションに参加しています。明日もご来訪ください。",
    "attendance_empty": "申し訳ありませんが、現在チェックインミッションはありません。",
    "congratulations": "おめでとうございます！",
    "gift_reward_won": "報酬を獲得しました！",
    "point_reward_won": "ポイントを獲得しました！",
    "attendance_enter_shipping": "報酬を受け取るための配送先住所を入力しますか？",
    "later_input": "後で入力する",
    "attendance_confirm": "確認",
    "go_back": "前のページに戻る",
    "connections_search_placeholder": "ニックネームを入力してください...",
    "connections_followers": "フォロワー",
    "connections_following": "フォロー中",
    "connections_recommendations": "推奨",
    "connections_no_search_results": "検索結果がありません！",
    "connections_no_followers": "フォロワーがまだいません。",
    "connections_make_friends": "他のユーザーと友達になってみてください！",
    "connections_no_following": "まだ誰もフォローしていません。",
    "connections_no_users_found": "ユーザーが見つかりません。",
    "connections_refresh_recommendations": "推奨を更新する",
    "follow": "フォロー",
    "unfollow": "フォロー解除",
    "button_following": "フォロー中",
    "follow_cancelled": "フォローがキャンセルされました",
    "follow_started": "フォローを開始しました",
    "follow_status_change_failed": "フォローステータスの変更に失敗しました。",
    "bonus_points_earned": "ボーナスポイントが獲得されました。",
    "edited_label": "（編集済み）",
    "leader_label": "リーダー",
    "event_roulette": "ルーレット",
    "event_attendance": "毎日チェックイン",
    "event_free_trial": "無料体験",
    "event_qualification_test": "適格テスト",
    "shipping_address_info": "配送先住所",
    "select_address": "配送先を選択",
    "registering_address": "配送先を登録中...",
    "roulette_no_missions": "申し訳ございませんが、実施中のルーレットミッションがありません。",
    "roulette_unlucky": "残念です!<br/>次回も挑戦してください!",
    "roulette_lucky_points": "おめでとうございます!{points}ポイントに当選しました!",
    "roulette_lucky_gift": "おめでとうございます!{productName}に当選しました!{productName}の景品を受け取るための住所を入力しますか?",
    "roulette_enter_shipping": "配送先を入力",
    "roulette_confirm": "確認",
    "roulette_share_title": "共有して追加のチャンスを獲得！",
    "roulette_share_description": "SNSに共有すると、1日最大{maxShares}回まで追加のルーレットチャンスが与えられます。<br/>（現在の共有回数：{sharesUsed}/{maxShares}回）",
    "roulette_share_accept": "共有する",
    "roulette_share_cancel": "閉じる",
    "roulette_share_success": "共有が完了し、追加のチャンスが提供されました！",
    "roulette_share_toast_success": "リンクがコピーされました。追加のルーレットチャンスが1回付与されました！",
    "level_up_congratulations": "おめでとうございます!{levelName}を達成しました!{points}ポイントが獲得されました!",
    "roulette_congratulations": "おめでとうございます!",
    "roulette_gift_won": "に当選しました!",
    "roulette_gift_reward_address": "景品を受け取るための住所を入力しますか?",
    "roulette_gift_question": "詳細を入力しに行きませんか?",
    "challenge_event_name": "チャレンジ/イベント名",
    "roulette_won": "当選",
    "personal_info_collection_details": "個人情報収集・使用の詳細",
    "company_processing_notice": "当社はイベント実施および景品配送のため、以下の業務を処理します。",
    "contractor_label": "受託者",
    "contractor_name": "ハンジン宅配",
    "contractor_purpose": "景品配送",
    "refuse_collection_notice": "上記の個人情報の収集・使用への同意を拒否する権利があります。ただし、同意を拒否する場合、イベント参加およびサービス提供の対象から除外されることをご了承ください。",
    "shipping_success_message": "ありがとうございます!<br />お客様のギフトは準備中で、間もなく発送される予定です<br />ご注文情報をご確認ください。",
    "withdrawal_title": "アカウント削除",
    "withdrawal_confirm_question": "本当に退会しますか?",
    "withdrawal_content_info": "お客様のコンテンツとポイントは次の通りです:",
    "my_posts": "私の投稿",
    "my_points": "私のポイント",
    "scheduled_shipping": "配送予定",
    "withdrawal_warning_1": "退会すると、作成した投稿とポイントがすべて削除されます。",
    "withdrawal_warning_2": "退会後も配送予定の商品は配送されますが、詳細を確認することが難しい場合があります。",
    "withdrawal_button": "退会する",
    "withdrawal_cancel": "キャンセル",
    "comment_actions_post": "コメント",
    "comment_delete": "削除",
    "comment_cancel": "キャンセル",
    "comment_banned": "このコメントは禁止されています。",
    "comment_deleted_by_admin": "このコメントは管理者によって削除されました",
    "comment_reported": "このコメントは報告されています。",
    "comment_deleted_by_owner": "オーナーがコメントを削除しました。",
    "comment_view_more": "{count}件以上のコメントを表示",
    "comment_hide": "コメントを非表示",
    "comment_placeholder": "コメントを追加...",
    "comment_max_images": "最大5つの画像のみアップロードできます。",
    "comment_deleted": "コメントが削除されました。",
    "comment_created": "コメントが作成されました。",
    "comment_reported_submitted": "レポートが提出されました。",
    "comment_hidden": "コメントが非表示です。",
    "comment_hide_error": "コメント非表示中にエラーが発生しました。",
    "post_made_private": "投稿がプライベートに変更されました。",
    "post_made_public": "投稿が公開に変更されました。",
    "user_blocked_success": "ユーザーが正常にブロックされました。このユーザーの投稿は表示されなくなります。",
    "user_block_error": "ユーザーをブロック中にエラーが発生しました。",
    "post_detail_sort": "ソート",
    "challenge_ended": "チャレンジ終了",
    "time_remaining": "残り時間",
    "today_news": "今日のジョーカーニュース",
    "year_unit": "年",
    "month_unit": "月",
    "day_unit": "日",
    "day_sun": "日",
    "day_mon": "月",
    "day_tue": "火",
    "day_wed": "水",
    "day_thu": "木",
    "day_fri": "金",
    "day_sat": "土",
    "view_post_detail": "投稿の詳細を表示",
    "join_mission": "ウィークリーミッション参加",
    "check_winner": "当選者確認",
    "participation_complete": "参加完了",
    "post_reported_success": "投稿が正常に報告されました。",
    "product_selling": "販売中",
    "product_reserved": "予約中",
    "product_sold": "完売",
    "status_changed": "ステータスが",
    "status_changed_suffix": "に変更されました。",
    "status_change_failed": "ステータスの変更に失敗しました",
    "no_comments_yet": "まだコメントがありません",
    "be_first_commenter": "最初のコメントを投稿してください。",
    "submit_additional": "追加提出",
    "submit_payment": "支払い",
    "yes_payment": "はい、支払います！",
    "challenge_fee_submission_part1": "このチャレンジは参加費",
    "challenge_fee_submission_part2": "を支払う必要があります",
    "challenge_fee_submission_part3": "出品が完了します。",
    "challenge_fee_submission_part4": "参加しますか？",
    "submission_not_completed_button": "出品が完了していません。",
    "challenge_fee_part1": "このチャレンジは",
    "challenge_fee_part2": "の参加料金が",
    "challenge_fee_part3": "発生する有料チャレンジです。",
    "yes_proceed": "はい、進めます！",
    "no_button": "いいえ",
    "challenge_fee_refund_part1": "支払い後、チャレンジに参加しない場合、",
    "challenge_fee_refund_part2": "チャレンジ期間終了後に全額返金",
    "challenge_fee_refund_part3": "が行われます。",
    "challenge_fee_refund_part4": "続行しますか？",
    "draft_continue_confirm": "保存された出品情報を引き続き作成しますか？",
    "draft_new_info": "新しい出品情報を作成する場合、",
    "draft_info_disappear": "保存されたコンテンツは削除されます。",
    "draft_saved_at": "に保存された",
    "draft_has_content": "出品コンテンツがあります。",
    "draft_create_new": "新規作成",
    "draft_continue_writing": "引き続き作成",
    "multi_submit_challenge_info": "複数の提出が可能なチャレンジであり、",
    "submit_count_unlimited": "提出数に関係なく参加できます。",
    "challenge_participate_confirm": "参加しますか？",
    "already_participated": "このチャレンジに既に参加しています。",
    "yes_submit_additional": "はい、追加提出します！",
    "something_went_wrong": "何か問題が発生しました",
    "make_payment": "支払う",
    "payment_info": "決済情報",
    "payment_method_selection": "支払い方法",
    "agree_payment_terms": "決済および利用規約に同意します",
    "payment_cancel_notice": "支払いキャンセルは支払い日から7日以内のみ可能です。",
    "minor_consent_notice_part1": "未成年者の場合、支払い時に法定代理人の同意が必要であり、",
    "minor_consent_notice_part2": "その旨、法定代理人の同意を得たことを確認します。",
    "electronic_payment_terms": "電子金融取引利用規約",
    "chapter1_general": "第1章：総則",
    "article1_purpose": "第1条（目的）本規約は、本サービスを利用するユーザーとサービスプロバイダー間の権利、義務、責任事項およびその他必要な事項を規定することを目的としています。",
    "article2_definitions": "第2条（用語の定義）",
    "article2_service": "「サービス」とは、会社が提供する各種サービスを意味します。",
    "article2_user": "「ユーザー」とは、本規約に同意し、会社が提供するサービスを利用する者をいいます。",
    "chapter2_service_contract": "第2章：サービス利用契約",
    "chapter2_content": "1. サービス利用契約は、ユーザーが規約に同意し、会社が定めた登録様式を作成して提出することで成立します。ユーザーはサービス申し込み時に提供されるすべての情報が実際の情報であり、正確に提供される必要があります。",
    "chapter3_service_use_management": "第3章：サービス利用および管理",
    "article4_provision_change": "第4条（サービスの提供および変更）",
    "article4_content1": "会社はユーザーにサービスを提供することができ、提供するサービスの内容は会社の方針に従います。",
    "article4_content2": "会社は運営上または技術上の必要に応じてサービスの内容を変更することができます。",
    "article5_interruption": "第5条（サービスの中断）",
    "article5_content": "会社は、以下のいずれかに該当する場合、サービスの全部または一部を中断することができます。a. 定期的または不定期的なサーバーメンテナンス時、b. 自然災害、戦争、テロ、運営上の重大な事故などの不可抗力の原因が発生した場合",
    "points_exchange_notice": "貯めたポイントで折り紙製品と交換できます。",
    "all_categories": "すべて",
    "points_highest": "ポイントが高い順",
    "points_lowest": "ポイントが低い順",
    "points_sort_title": "ソート",
    "login_info_error": "ログイン情報を取得できません。",
    "contact_support": "カスタマーサポートにお問い合わせください。",
    "register_again_confirm": "もう一度登録しますか？",
    "account_unavailable": "お客様のアカウントは利用できません",
    "login_with_naver": "Naverでログイン",
    "login_with_kakao": "Kakaoでログイン",
    "login_with_google": "Googleでログイン",
    "login_with_apple": "Appleでログイン",
    "post_updated": "投稿が更新されました。",
    "max_media_count": "最大10枚の画像がアップロードできます。",
    "file_too_large": "画像は最大10MBまでアップロードできます。",
    "caption_required": "内容を入力してください。",
    "tags_required": "タグを少なくとも1つ入力してください。",
    "media_required": "画像または動画を追加してください。",
    "tag_max_length_error": "タグは50文字以下で入力してください。",
    "changes_lost": "変更がすべて失われます。<br />編集ページを離れますか？",
    "select_group": "グループを選択",
    "video_url_input": "動画URLを入力",
    "sort": "並べ替え",
    "select_photos_videos": "ギャラリーから写真/動画を選択",
    "register_video_by_url": "URLで動画を登録",
    "attach": "添付",
    "board_selection": "掲示板を選択",
    "type": "タイプ",
    "image_type": "画像",
    "video_url_type": "動画URL",
    "default_group": "デフォルト",
    "product_name_placeholder": "商品名を入力してください。",
    "content_placeholder": "内容を入力してください。",
    "tag_input": "タグ入力",
    "tag_placeholder": "タグを入力してください。",
    "tag_input_button": "追加",
    "max_tags_error": "最大{count}個までタグを追加できます。",
    "price_input": "価格入力",
    "price_placeholder": "金額を入力してください。",
    "url_label": "URL",
    "url_placeholder": "URLを入力 (https://youtube.com)",
    "url_check_button": "確認",
    "url_error_message": "リンクアドレスが正しくありません。",
    "youtube_support_info": "現在、YouTubeビデオのみがサポートされています。",
    "youtube_share_instruction": "YouTubeで共有ボタンをクリックして、提供されたURLを入力してください。",
    "url_preview_instruction": "確認ボタンをクリックして、プレビューが正しく表示されていることを確認してください。",
    "challenge_available": "参加可能なチャレンジが",
    "challenge_count_unit": "個",
    "challenge_available_suffix": "あります！",
    "bonus_points_earned_title": "{points}ポイントが獲得されました。",
    "points_of_user": "のポイント",
    "unknown_user": "UNKNOWN",
    "no_blocked_users": "ブロックしたユーザーはいません。",
    "blocked_at": "ブロック日",
    "unblock": "ブロック解除",
    "unblock_confirm": "ブロックを解除しますか？",
    "unblock_confirm_description": "{nickname} さんのブロックを解除します。",
    "unblock_success": "ブロックを解除しました。",
    "unblock_error": "ブロック解除に失敗しました。",
    "blocked_user_unknown_nickname": "不明なユーザー",
    "blocked_users_management": "ブロックリスト",
    "view_store_products": "何がもらえるか見る",
    "retry": "再試行",
    "write_first_post": "最初の投稿を書く",
    "clear_filter": "条件をクリア",
    "no_products_for_filter": "'{condition}'条件に合う商品がありません。",
    "failed_to_load_list": "リストの読み込みに失敗しました。",
    "browse_store": "ストアを見る",
    "privacy_management": "ブロック管理",
    "user_default_name": "ユーザー",
    "message_send_failed": "メッセージの送信に失敗しました。",
    "image_send_failed": "画像の送信に失敗しました。",
    "no_messages": "メッセージはありません",
    "message_media_alt": "Message media",
    "image_upload_limit": "最大10個までしかアップロードできません。",
    "message_input_placeholder": "メッセージを送信...",
    "blocked_user_message": "ブロックされたユーザーにはメッセージを送信できません",
    "message_send_error": "メッセージの送信に失敗しました。",
    "post_author": "著者",
    "challenges_all": "すべて",
    "challenges_participable": "参加できる",
    "challenges_participated": "既に参加した",
    "select_inquiry_period": "照会期間を選択",
    "read_more": "... もっと見る",
    "show_less": "折りたたむ",
    "order_number": "注文番号",
    "order_date": "注文日",
    "point_exchange_product": "ポイント交換商品",
    "quantity": "数量",
    "tracking_code": "追跡番号",
    "no_tracking_code": "追跡番号がありません",
    "tracking_code_preparing": "追跡番号を準備中",
    "order_cancelled": "注文キャンセル",
    "total_payment": "総支払額",
    "total_exchange_points": "総交換ポイント",
    "rating": "評価を残す",
    "select_rating": "評価を選択してください。",
    "product_info_missing": "商品情報がありません。",
    "rating_saved": "評価が保存されました。",
    "rating_save_failed": "評価の保存に失敗しました。",
    "loading_rating_info": "評価情報を読み込み中...",
    "saving": "保存中...",
    "shipping_address": "配送先情報",
    "insufficient_points": "ポイント不足です",
    "insufficient_points_message": "ポイントが不足している場合、",
    "participate_challenge": "ポイントを獲得するチャレンジに参加",
    "participate_challenge_suffix": "してみてください！",
    "exchange_button": "交換する",
    "insufficient_points_exchange": "この商品を交換するのに十分なポイントがありません。",
    "exchange_address_submit_failed": "景品の配送先アドレス提出に失敗しました。",
    "exchange_address_submit_failed_message": "もう一度お試いただくか、問題が繰り返される場合はカスタマーサービスにお問い合わせください。<br />ありがとうございます。",
    "exchange_return_policy": "ご希望でしたら、購入した商品のポイントを払い戻します。ただし、以下の場合は返品ができません:",
    "exchange_policy_1": "商品受取から7日以上経過している場合",
    "exchange_policy_2": "受け取った商品を開封した場合で、再販売不可の場合",
    "exchange_product": "交換商品",
    "personal_info_collection_consent": "商品受け取りのための個人情報の収集と使用に関する同意",
    "field_required_template": "$項目名$を入力してください。",
    "address_detail": "詳細住所",
    "prize_receipt_not_possible": "景品の受け取りはできません。",
    "personal_data_not_agreed": "個人情報の収集と使用に同意しない場合、<br />景品を送付することはできません。",
    "exchange_complete": "交換完了！",
    "exchange_success_message": "ありがとうございます！<br />ご登録いただいたギフトの準備中で、まもなく発送される予定です。<br />引き続き注文情報をご確認ください。",
    "enter_shipping_address": "配送先の入力",
    "agree_personal_info_collection": "上記のように個人情報の収集と使用に同意しますか？",
    "change_shipping_address": "配送先の変更",
    "add_shipping_address": "配送先を追加+",
    "submit": "提出",
    "privacy_info_title": "個人情報の収集と使用の詳細",
    "collection_purpose_text": "イベント景品の配送と配送",
    "retention_period_text": "景品配送完了後最大3ヶ月",
    "personal_info_items": "個人情報の収集項目",
    "personal_info_items_text": "名前、電話番号、配送先住所",
    "company_process_text": "イベント開催および景品配送のため、以下のように業務を処理いたします。",
    "contractor": "受託社",
    "contractor_names": "ハンジン宅配",
    "purpose": "目的",
    "purpose_text": "景品配送",
    "refusal_notice": "上記の個人情報の収集と使用について、同意を拒否する権利があります。ただし、同意を拒否された場合、イベント開催およびサービス提供の対象から除外されることをご了承ください。",
    "product_receipt_notice": "商品受け取りのお知らせ",
    "receipt_within_two_weeks": "配送先の入力後、2週間以内に景品を受け取ることができます。",
    "wrong_address_responsibility": "配送先の誤入力等の過失は当選者本人が負担します。",
    "inquiry_about_prize": "景品配送に関するお問い合わせは",
    "to_use": "をご利用ください。",
    "exchange_success_completed": "商品交換が正常に完了しました",
    "received": "受け取った",
    "no_points_yet": "まだポイントがありません。",
    "exchange": "交換",
    "seller_info_not_found": "販売者情報が見つかりません。",
    "dm_button": "DM",
    "user_channel": "のチャンネル",
    "send_dm": "DMを送信",
    "follow_button": "フォロー",
    "group": "グループ",
    "user_deleted_msg": "ユーザーが削除されました。",
    "user_suspended_msg": "ユーザーが一時停止されました。",
    "user_payment_cancelled_msg": "支払いがキャンセルされました。",
    "points_deduction_confirmation": "{points}ポイントが差し引かれます",
    "insufficient_points_title": "ポイント不足",
    "insufficient_points_message_2": "現在、ポイントが不足しています。\nより多くのアクティビティを通じてポイントを獲得してください!",
    "agree_all_terms": "すべてに同意する",
    "you_can_use_service_even_without_optional_agreement": "オプション項目に同意しない場合でも、サービスを利用できます。",
    "terms_of_service_agreement": "利用規約に同意 (必須)",
    "privacy_policy_agreement": "個人情報の収集と使用に同意 (必須)",
    "age_confirmation": "14歳以上です。",
    "check_terms_of_service": "利用規約をご確認ください。",
    "setup_email_title": "メールアドレスを設定してください。",
    "email_label": "メール",
    "email_address_placeholder": "メールアドレスを入力してください。",
    "setup_phone_title": "電話番号を入力してください。",
    "phone_number_label": "携帯電話番号",
    "phone_number_input_placeholder": "電話番号を入力してください。",
    "invalid_phone_number_error": "有効な電話番号を入力してください。",
    "optional_notice": "これはオプションであり、同意しなくてもサービスを利用できます。",
    "setup_referrer_title": "紹介者のニックネームを入力してください。",
    "nickname_label": "ニックネーム",
    "referrer_nickname_placeholder": "紹介者のニックネームを入力してください。",
    "nickname_does_not_exist_error": "このニックネームは存在しません。",
    "referrer_optional_notice": "これはオプションです。最初の登録時に{referralPoints}ポイント獲得します。",
    "setup_personal_info_title": "個人情報を入力してください。",
    "age_label": "年齢",
    "age_input_placeholder": "年齢を数字で入力してください。",
    "birthdate_label": "生年月日",
    "select_birthdate": "生年月日を選択してください。",
    "birthdate_placeholder": "生年月日を入力してください。",
    "origami_experience_label": "折り紙の経験",
    "personal_info_optional_notice": "これはオプションです。最初の登録時に{updateProfilePoints}ポイント獲得します。",
    "setup_profile_title": "プロフィールを設定してください。",
    "image_upload_help_text": "1200x810pxサイズの画像をアップロードしてください。",
    "sold_out": "売り切れ",
    "cart_added_success": "商品が買い物かごに追加されました。",
    "continue_shopping": "買い物を続ける",
    "go_to_cart": "買い物かごへ移動",
    "un_authentication_message": "ログインが必要です。<br /><br />ログイン画面に移動しますか？",
    "total_amount_per_item": "合計金額",
    "order_product_total": "注文商品合計",
    "membership_discount_with_percent": "メンバーシップ割引 {percent}%",
    "select_option": "商品を選択してください。",
    "add_to_cart": "買い物かごに入れる",
    "buy_now": "今すぐ購入",
    "cart_title": "買い物かご",
    "cart_empty": "買い物かごは空です。",
    "order_confirmation_title": "注文の確認",
    "buy_all_items_confirm": "買い物かごにある{count}点すべての商品を購入しますか？",
    "select_all_with_count": "すべて ({count})",
    "delete_all": "すべて削除",
    "delete_selected_item_confirm": "選択した商品を削除しますか？",
    "delete_selected": "選択削除",
    "total_product_amount": "合計商品金額",
    "total_shipping_fee": "合計配送料",
    "estimated_payment_amount": "支払い予定金額",
    "buy_all_products": "すべての商品を購入",
    "buy_selected_products": "選択した商品を購入",
    "follow_success": "フォローしました。",
    "unfollow_success": "フォローを解除しました。",
    "point_earned_like": "コンテンツへの「いいね」でポイントが貯まりました。",
    "point_earned_comment": "コメントの作成でポイントが貯まりました。",
    "onboarding_board_description": "友達が投稿した折り紙作品と\n専門家のコツを\n一か所で見ることができます。",
    "onboarding_joker_market_description": "自分が作った折り紙を自慢し、\n希望の価格で販売できます。",
    "onboarding_newsletter_description": "ジョイサムのお知らせと折り紙の専門情報を\n素早く受け取ることができます。",
    "onboarding_follow_description": "気の合う友達をフォローして、\nお互いの折り紙の情報を\n共有できます。",
    "onboarding_store_description": "さまざまな折り紙用品を\n簡単に便利に購入できます。",
    "onboarding_skip": "スキップ",
    "onboarding_get_started": "はじめる",
    "login_token_expired": "ログイントークンの有効期限が切れました。もう一度ログインしてください。",
    "server_response_unavailable": "サーバーからの応答を受信できません。もう一度お試しください。",
    "server_response_data_missing": "サーバーの応答に必要なデータがありません。",
    "profile_nickname_placeholder": "ニックネームを作ってください!",
    "required_badge": "(必須)",
    "not_logged_in_title": "ログインしていません。",
    "go_to_login_confirm": "ログインページに移動しますか?",
    "joker_event_section_title": "ジョーカーイベント",
    "myroom_banner_aria_label": "折り紙の部屋を飾る — マイルームへ",
    "myroom_banner_alt": "折り紙の部屋を飾る - 3D空間に自分だけの折り紙を展示してみましょう。",
    "myroom_card_accent": "マイルーム",
    "myroom_card_title_linked": "私だけの3D空間",
    "myroom_card_title_new": "折り紙の部屋を飾る",
    "myroom_card_title_onboarding": "登録が完了していません",
    "myroom_card_subtitle": "3D空間に自分だけの折り紙を展示してみましょう。",
    "myroom_card_cta_linked": "マイルームへ",
    "myroom_card_cta_new": "マイルームを飾りに行く",
    "myroom_card_cta_onboarding": "マイルームの登録を続ける",
    "myroom_card_item_badge": "完成した3Dアイテムがあります",
    "myroom_card_item_done_title": "3Dアイテム完成",
    "myroom_card_item_done_message": "{name}が完成しました。\nアイテムを配置しますか？",
    "myroom_card_item_later": "あとで",
    "myroom_card_item_place": "配置する",
    "myroom_cash_title": "ポイントをマイルームキャッシュに交換",
    "myroom_cash_sub_min": "{min}Pから交換できます",
    "myroom_cash_sub_balance": "保有{points}P → 今交換すると{cash}C",
    "store_cat_best": "ベスト",
    "store_cat_origami_books": "折り紙の本",
    "store_cat_colored_paper": "折り紙",
    "store_cat_other_tools": "その他の道具",
    "store_cat_sets": "セット商品",
    "pending_deposit_one": "入金を待っている注文があります",
    "pending_deposit_many": "入金を待っている注文が{count}件あります",
    "see_account": "口座を見る",
    "myroom_misc_update_title": "アプリのアップデートが必要です",
    "myroom_misc_update_message": "マイルームは最新バージョンのアプリでご利用いただけます。\nApp StoreでJoySam Connectをアップデートしてください。",
    "myroom_frame_err_invalid_assertion": "接続情報が正しくありません。\nもう一度お試しください。",
    "myroom_frame_err_expired_assertion": "接続情報の有効期限が切れました。\nもう一度お試しください。",
    "myroom_frame_err_network": "接続が不安定です。\nしばらくしてからもう一度お試しください。",
    "myroom_frame_err_server": "マイルームで一時的な問題が発生しています。\nしばらくしてからもう一度お試しください。",
    "myroom_frame_err_unknown": "しばらくしてからもう一度お試しください。",
    "myroom_frame_rejected_withdrawn_title": "マイルームを退会したアカウントです",
    "myroom_frame_rejected_withdrawn_body": "退会後14日間は再接続できません。",
    "myroom_frame_rejected_fallback_title": "マイルームに接続できません",
    "myroom_frame_rejected_fallback_body": "現在、このアカウントは接続できません。\nカスタマーセンターにお問い合わせください。",
    "myroom_frame_date_fmt": "{m}月{d}日",
    "myroom_frame_can_reconnect": "{date}から再接続できます。",
    "myroom_frame_can_reconnect_days": "{date}({days}日後)から再接続できます。",
    "myroom_frame_sample_info_failed": "サンプルルームの情報を読み込めませんでした。",
    "myroom_frame_sample_load_failed": "サンプルルームを読み込めません。",
    "myroom_frame_enter_info_failed": "ルームへの入室情報を読み込めませんでした。",
    "myroom_frame_enter_failed": "ルームに入れません。",
    "myroom_frame_connecting": "マイルームに接続中です…",
    "myroom_frame_session_failed": "セッションの交換に失敗しました。",
    "myroom_frame_session_error": "セッションの交換中にエラーが発生しました。",
    "myroom_frame_connected": "マイルームに接続しました",
    "myroom_frame_link_done": "マイルームの連携が完了しました",
    "myroom_frame_already_linked": "すでに連携されています",
    "myroom_frame_link_expired": "連携の制限時間が過ぎました。もう一度お試しください",
    "myroom_frame_connect_failed_retry": "マイルームへの接続に失敗しました。しばらくしてからもう一度お試しください。",
    "myroom_frame_connect_failed": "マイルームへの接続に失敗しました。",
    "myroom_frame_consent_title": "マイルーム連携",
    "myroom_frame_consent_existing_1": "すでに作成済みのマイルームアカウントがあります。",
    "myroom_frame_consent_existing_2": "続けると、そのアカウントにジョイサムのアカウントが連携され、自分のルームに入ります。",
    "myroom_frame_consent_new_1": "ジョイサムのアカウントでマイルームを始めます。",
    "myroom_frame_consent_new_2": "続けると、ジョイサムのアカウントとマイルームが連携されます。",
    "myroom_frame_consenting": "接続中…",
    "myroom_frame_agree_existing": "同意して自分のルームへ",
    "myroom_frame_agree_new": "同意して始める",
    "myroom_frame_back": "戻る",
    "myroom_frame_back_aria": "ジョイサムに戻る",
    "myroom_frame_friend": "お友達",
    "myroom_frame_friend_not_started": "{name}さんは\nまだマイルームを始めていません",
    "myroom_frame_title_link_needed": "マイルームの連携が必要です",
    "myroom_frame_title_login_needed": "ログインが必要です",
    "myroom_frame_title_cannot_open": "ルームを開けません",
    "myroom_frame_desc_unavailable": "お友達がマイルームを始めると、ルームを見に行けます。",
    "myroom_frame_desc_login": "もう一度ログインしてから、マイルームに入ってください。",
    "myroom_frame_desc_link_required": "マイルームはGoogle・カカオ・Apple・LINEのアカウントで始めます。\nNaverで登録した方は、そのうちのひとつを選んでください。\nジョイサムのアカウントとこれまでの活動はそのままです。\n\nブラウザでログインを終えると、すぐに戻ってきます。",
    "myroom_frame_desc_social_required": "マイルームはGoogle・カカオ・Apple・LINEのアカウントで連携します。\nそのうちのひとつでログインすると\nマイルームを利用できます。",
    "myroom_frame_btn_finish_signup": "マイルームの登録を完了する",
    "myroom_frame_btn_my_room": "自分のルームへ",
    "myroom_frame_btn_link": "マイルームを連携する",
    "myroom_frame_btn_social_login": "ソーシャルアカウントでログイン",
    "myroom_frame_btn_login": "ログイン",
    "myroom_frame_btn_retry": "もう一度試す",
    "myroom_frame_browser_hint": "ブラウザが開きませんでしたか?\nアドレスをコピーして、ChromeやSamsung Internetに貼り付けてください。\nPCでジョイサムにログインして連携することもできます。",
    "myroom_frame_copied": "コピーしました",
    "myroom_frame_copy_link": "連携アドレスをコピー",
    "myroom_frame_loading_room": "ルームを読み込み中です…",
    "bottom_nav_modal_confirm": "確認",
    "expert_channel_section_title": "ジョイサムと一緒にする専門家チャンネル",
    "expert_channel_empty_message": "まだ登録された専門家がいません。<br />積極的に活動して最初の専門家になってみましょう。",
    "content_slider_exam_title": "進行中の資格試験",
    "content_slider_exam_content": "2024年大韓民国「子供折り紙3級」資格試験のための学習をお願いします...",
    "popular_posts_section_title": "わいわいコミュニティ投稿",
    "popular_posts_empty_message": "直近12時間以内に作成された人気投稿がありません。",
    "certificate_application": "資格証申請",
    "payment_complete_status": "決済完了",
    "product_prep_status": "商品準備中",
    "shipping_start_status": "配送開始",
    "vbank_share_title": "[ジョイセム コネクト] 入金案内",
    "depositor": "振込人名義",
    "deposit_amount": "入金金額",
    "deposit_deadline": "入金期限",
    "until": "まで",
    "smart_delivery_tracking": "スマート宅配便配送照会",
    "order_cancel_confirm_title": "注文をキャンセルしますか?",
    "order_cancel_confirm_message": "注文をキャンセルすると、返金はカード会社により営業日基準で3〜5日ほどかかります。",
    "order_cancel_done_title": "注文をキャンセルしました",
    "order_cancel_done_message": "お支払い金額の返金をリクエストしました。<br />返金はカード会社により営業日基準で3〜5日ほどかかります。",
    "payment_form_load_error": "決済画面を読み込めませんでした。もう一度お試しください。",
    "payment_form_submit_title": "決済フォーム送信",
    "nickname_fallback_default": "ユーザー",
    "order_cancel": "注文キャンセル",
    "save_complete_title": "保存が完了しました",
    "withdrawal_error": "会員退会中にエラーが発生しました。",
    "congrats_bonus_points_title": "おめでとうございます!<br>{points}ポイントが獲得されました!",
    "marketing_consent_notice": "{year}年{month}月{day}日にジョイセムが提供するマーケティング情報の受信に{consent}。",
    "marketing_consent_agreed": "同意しました",
    "marketing_consent_disagreed": "同意しませんでした",
    "submit_work_step_photo_registration": "作品写真登録",
    "login_required_confirm_message": "ログインしていません。続けるにはログインしてください。<br/>ログイン画面に移動しますか？",
    "temp_save_success": "一時保存しました。",
    "unsupported_image_format": "サポートされていない画像形式です",
    "field_title_ko": "作品名（韓国語）",
    "field_title_en": "作品名（英語）",
    "field_width": "幅",
    "field_height": "高さ",
    "field_length": "奥行き",
    "field_description": "作品説明",
    "field_work_type": "作品の形態（形）",
    "field_number_of_paper": "使用した紙の枚数（枚）",
    "field_used_paper_shapes": "使用した紙の形",
    "field_has_cut_marks": "切り込み",
    "field_is_glued": "のり付け",
    "field_finished_shape": "完成形の状態",
    "field_primary_folding_method": "基本形",
    "field_target_age": "対象年齢（難易度）",
    "field_submitter_name_ko": "氏名（韓国語）",
    "field_submitter_name_en": "氏名（英語）",
    "field_birthdate": "生年月日",
    "field_country": "国",
    "field_address1": "住所",
    "field_address2": "詳細住所",
    "field_mobile": "携帯電話番号",
    "field_phone": "電話番号",
    "field_email": "メール",
    "field_social_media_url": "SNSアドレス",
    "field_gender": "性別",
    "field_is_creator": "制作者本人です",
    "field_co_maker": "共同制作の有無",
    "field_required_suffix": "項目を入力してください。",
    "submit_button": "提出する",
    "submit_work_title": "作品提出",
    "temp_save": "一時保存",
    "leave_without_saving_title": "変更内容を保存せずに移動しますか？",
    "leave_without_saving_description": "入力内容は一時保存されます。",
    "submit_photo_face": "正面",
    "submit_photo_back": "背面",
    "submit_photo_left": "左側面",
    "submit_photo_right": "右側面",
    "unsupported_image_format_title": "{name}画像の{file}はサポートされていない画像形式です。",
    "max_5_photos_limit": "最大5枚までの写真・動画のみ登録できます。",
    "option_has": "あります",
    "option_none": "ありません",
    "select_target_age_title": "対象年齢（難易度）選択",
    "select_completed_state_title": "完成形の状態選択",
    "select_basic_type_title": "基本形選択",
    "select_paper_shape_title": "使用した紙の形選択",
    "placeholder_input_korean": "韓国語で入力してください。",
    "placeholder_input_english": "英語で入力してください。",
    "field_work_dimension": "作品規格（cm）",
    "dimension_range_error": "0.01～10000の間の数字を入力してください。",
    "placeholder_work_shape_description": "動物/恐竜/植物/乗り物/キャラクター/建物/遺跡/図形/記号/文字/虫/魚などで形を説明してください。",
    "placeholder_input_paper_count": "使用した紙の枚数を入力してください。",
    "placeholder_select_paper_shape": "紙の形を選択してください。",
    "placeholder_input_finished_shape": "完成形の状態を入力してください。",
    "placeholder_input_basic_type": "基本形を入力してください。",
    "placeholder_input_target_age": "対象年齢（難易度）を入力してください。",
    "placeholder_numbers_only": "数字のみ入力してください。",
    "placeholder_input_mobile": "携帯電話番号を入力してください。",
    "placeholder_input_email": "メールアドレスを入力してください。",
    "placeholder_input_sns_url": "SNSアドレスを入力してください。",
    "gender_male": "男性",
    "gender_female": "女性",
    "checkbox_is_creator": "制作者本人です。",
    "required_marker": "（必須）",
    "submitter_legal_responsibility_notice": "本人でない場合、法的責任は提出者本人にあり、当選が取り消される場合があります。",
    "privacy_consent_notice_html": "<p style=\"font-weight: 700; font-size: 12px; margin-top: 0; margin-bottom: 20px\">コンテストに参加する場合、追加の個人情報を収集します。</p><p style=\"font-weight: 400; font-size: 12px; margin-top: 0; margin-bottom: 20px\">ジョイシンは個人情報保護法第30条に基づき、以下の目的のために個人情報を処理します。処理される個人情報は以下の目的以外の用途には利用されず、利用目的が変更される場合は同法第18条に基づき、別途同意を得るなど必要な措置を講じます。</p><div><span>個人情報の収集及び利用内訳</span><ul><li>収集及び利用目的：コンテスト参加のための参加者の個人識別</li><li>保有期間：参加日から5年間保管（電子商取引等における消費者保護に関する法律）<br/>ただし、関連法令及び会社ポリシーにより別途保管される情報は例外とします</li><li>個人情報収集項目：氏名、携帯電話番号、受取先住所</li></ul></div><div><span>個人情報収集項目</span><ul><li>必須：氏名（韓国語）、氏名（英語）、生年月日、携帯電話番号、住所</li><li>任意：性別、電話番号、メール、SNSアドレス、共同制作者情報</li></ul></div><span>上記の個人情報の収集・利用に対する同意を拒否する権利があります。ただし、同意を拒否した場合、本イベントに関連するサービス提供の対象から除外されることがあります。</span>",
    "privacy_consent_confirm_question": "上記のように個人情報を収集・利用することに同意しますか？",
    "select_country_title": "国選択",
    "co_maker_alone": "一人でやりました",
    "co_maker_together": "一緒にやりました",
    "field_co_maker_name_ko": "共同制作者名（韓国語）",
    "placeholder_co_maker_name": "名前（所属）の形式で記入してください。複数人の場合はカンマ（,）で区切ってください。",
    "seconds_unit": "秒",
    "free_trial_coming_soon_title": "無料体験サービスを準備中です。",
    "qualification_test_coming_soon_title": "資格試験サービスを準備中です。",
    "my_points_amount_line": "私のポイント：{amount}P",
    "points_remaining_line": "{lowest}Pまであと{remain}P",
    "no_news_registered": "登録されたニュースがありません",
    "shipping_modal_default_description": "紙の国 科学の国",
} as const;

export type JaTranslationKeys = keyof typeof jaTranslations;
